import { Injectable } from '@angular/core';
import { AuthGuardService } from '@shared/services/auth-guard.service';

@Injectable()
export class TaskAssignmentPermission {
  constructor(protected authGuardService: AuthGuardService) {}

  public get hasTaskManagementPermission(): boolean {
    return this.authGuardService.checkPermission(['pm_task_m']);
  }

  public get hasTaskViewPermission(): boolean {
    return this.authGuardService.checkPermission(['pm_task_v']);
  }
}
